import React, { useContext } from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import Portal from '@common/portal';
import { useChatToast } from '@components/chat/common/chatToast';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';
import { ChatModalEnum } from '@components/chat/hooks/useChatModals';
import { Position } from '@utils/hooks/usePosition';
import { copyString } from '@utils/common';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface MoreMenuProps {
  message: Message;
  visible: boolean;
  onClose: () => void;
  position: Position | undefined;
}

const MoreMenu = ({ message, visible, onClose, position }: MoreMenuProps) => {
  const { openModal, userData } = useContext<ChatContextType>(ChatContext);
  const ChatToast = useChatToast();
  const isMyMessage = message.userId === userData?.user.id;
  const isReport = !isMyMessage && message?.type === 'text';

  const handleClick = () => {
    const el = document.getElementById(`${message.id}`);
    const text = el?.innerText || '';

    copyString(
      () =>
        ChatToast({
          bottom: 72,
          content: '복사되었어요.',
        }),
      text,
    );
    onClose();
  };

  const handleReportClick = () => {
    openModal(ChatModalEnum.REPORT, message);
    onClose();
  };

  if (!visible) return null;

  return (
    <Portal selector="#chat">
      <div className={cx('moreMenuArea')} style={{ top: position?.top, left: position?.left }}>
        <a role={'button'} className={cx('menu')} onClick={handleClick}>
          복사하기
        </a>
        {isReport && (
          <a role={'button'} className={cx('menu')} onClick={handleReportClick}>
            신고하기
          </a>
        )}
      </div>
    </Portal>
  );
};

export default MoreMenu;
